/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TopInterventionTypeListDto } from '../../models/top-intervention-type-list-dto';

export interface GetAllQuestions$Params {}

export function getAllQuestions(
  http: HttpClient,
  rootUrl: string,
  params?: GetAllQuestions$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<TopInterventionTypeListDto>> {
  const rb = new RequestBuilder(rootUrl, getAllQuestions.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TopInterventionTypeListDto>;
    })
  );
}

getAllQuestions.PATH = '/v1/top-securite/questions';
